module.exports = __webpack_public_path__ + "img/help-dc.211ed850.svg";